import React from "react";
import styled from "styled-components";

export const CountdownSmall = ({ label, days, hours, minutes, seconds }) => {
  return (
    <>
      <CountdownContainer xCenter>
        <CountdownTitle>{label}</CountdownTitle>
        <GridRow>
          {days >= 1 && (
            <Outline xCenter>
              <Increment>{days}</Increment>
              <Label>Day{days !== 1 ? "s" : ""}</Label>
            </Outline>
          )}
          <Outline xCenter>
            <Increment>{hours}</Increment>
            <Label>Hour{hours !== 1 ? "s" : ""}</Label>
          </Outline>
          <Outline xCenter>
            <Increment>{minutes}</Increment>
            <Label>Min{minutes !== 1 ? "s" : ""}</Label>
          </Outline>
          {days < 1 && (
            <Outline xCenter>
              <Increment>{seconds}</Increment>
              <Label>Second{seconds !== 1 ? "s" : ""}</Label>
            </Outline>
          )}
        </GridRow>
      </CountdownContainer>
    </>
  );
};

const CountdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* position: absolute; */
  width: 350px;
  /* left: -10%;
  right: 0; */

  @media (max-width: 950px) {
    flex-direction: column;
    width: auto;
    /* left: -50%; */
    max-width: 420px;
    flex-shrink: 0;
    /* right: 0; */
    /* margin: auto; */
    /* inline-size: min-content; */
  }
`;

const CountdownTitle = styled.h3`
  font-size: max(1rem, 1vw);
  color: black;
  display: inline-block;
  width: 100%;
  text-transform: uppercase;
  margin-bottom: 2px;

  @media (max-width: 950px) {
    text-align: center;
  }
`;

const GridRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

`;

const Increment = styled.p`
  font-weight: 600;
  font-size: 40px;
  line-height: 1.25;
  margin: 0 0 5px 0;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 24px;
    line-height: 1;
  }

  @media (max-width: 950px) {
    font-size: 21px;
    line-height: 1;
  }
`;

const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  margin: 0;
  font-weight: 600;

  @media (max-width: 950px) {
    font-size: 13px;
    line-height: 1;
    margin: 0;
  }
`;

const Outline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1e1e1e;
  color: #ffffff;
  padding: 15px;
  border-radius: 3px;
  width: 50px;
  margin-left: 5px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 10px 5px;
  }
`;
